import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

type WarningBoxProps = {
    children: React.ReactNode;
};

export function WarningBox({ children }: WarningBoxProps) {
    return (
        <div className="bg-light-orange border border-dark-orange text-darker-orange rounded-md px-4 py-3 text-sm flex items-start gap-3">
            <WarningAmberIcon fontSize="small" className="flex-shrink-0 mt-0.5" />
            <div>{children}</div>
        </div>
    );
}
